import { useState, useEffect } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import Api from "../../admin/components/api/Api";
import Notification, { showToast } from "./notification/Notification";

const LocationCompletionModal = () => {
  const loggedInUser = useSelector((state) => state.auth.user);
  const userId = loggedInUser?.user?.id;

  const [showModal, setShowModal] = useState(false);
  const [states, setStates] = useState([]);
  const [selectedState, setSelectedState] = useState(null);
  const [cities, setCities] = useState([]);
  const [isCityDisabled, setIsCityDisabled] = useState(true);
  const [profile, setProfile] = useState({ id: userId });
  const [userDetails, setUserDetails] = useState(null);

  const getDetailsApi = Api({ url: `admin/user/id/${userId}` });
  const editDetailsApi = Api({ url: `admin/editUser` });
  const stateApi = Api({ url: `admin/states/${1}` });
  const cityApi = Api({ url: `admin/cities/${selectedState?.value}` });

  useEffect(() => {
    if (userId) {
      fetchUserData();
      fetchStates();
    }
  }, [userId]);

  // fetch cities when state changes
  useEffect(() => {
    if (selectedState) {
      fetchCities();
    }
  }, [selectedState]);

  const fetchUserData = async () => {
    try {
      const responseData = await getDetailsApi.fetchData();
      // console.log("User Details location:", responseData.data.user);

      const data = responseData.data.user ;
      setUserDetails(data);
      const hasCity = data.cities[0];
      // console.log(data)
      setProfile({
        ...profile, 
        first_name: data.first_name,
        last_name: data.last_name,
      })

      setShowModal(!hasCity);
      // setShowModal(hasCity);
    } catch (error) {
      console.error("Error fetching user details:", error);
    }
  };

  const fetchStates = async () => {
    try {
      const response = await stateApi.fetchData();
      if (response.data.statusType === "SUCCESS") {
        setStates(response.data.states);
      }
    } catch {
      setStates([]);
    }
  };

  const fetchCities = async () => {
    try {
      const response = await cityApi.fetchData();
      if (response.data.statusType === "SUCCESS") {
        setCities(response.data.cities);
        setIsCityDisabled(false);
      }
    } catch {
      setCities([]);
      setIsCityDisabled(true);
    }
  };

  const handleProfileSubmit = async (e) => {
    e.preventDefault();
    // setProfile({ 
    //   ...profile, 
    //   first_name: userDetails.first_name,
    //   last_name: userDetails.last_name,
    //   })
    console.log(profile)
    
    try {
      const responseData = await editDetailsApi.editData(profile);
      if (responseData.data.statusType === "SUCCESS") {
        showToast("Details Updated Successfully", { type: "success" });
        setShowModal(false); // close modal after save
      }
    } catch {
      showToast("Error Occurred", { type: "error" });
    }
  };

  return (
    <Modal
      show={showModal}
      onHide={() => setShowModal(false)}
      centered
      backdrop="static"
    >
      <Notification />
      <Modal.Header>
        <Modal.Title>Complete Your Profile</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* <p className="text-muted">Select your state and city</p> */}

        <Form onSubmit={handleProfileSubmit}>
          {/* State */}
          <Form.Group className="mb-3">
            <Form.Label>State</Form.Label>
            <Form.Select
              value={selectedState?.value || ""}
              onChange={(e) => {
                const selectedOption = e.target.selectedOptions[0];
                setSelectedState({
                  value: selectedOption.value,
                  label: selectedOption.text,
                });
              }}
            >
              <option value="">Select state</option>
              {states.map((state) => (
                <option key={state.id} value={state.id}>
                  {state.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          {/* City */}
          <Form.Group className="mb-4">
            <Form.Label>City</Form.Label>
            <Form.Select
              value={profile.city_id || ""}
              onChange={(e) =>
                setProfile({ ...profile, city_id: e.target.value })
              }
              disabled={isCityDisabled}
            >
              <option value="">Select city</option>
              {cities.map((city) => (
                <option key={city.id} value={city.id}>
                  {city.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          {/* Actions */}
          <div className="d-flex justify-content-between pt-4">
            <Button variant="secondary" onClick={() => setShowModal(false)}>
              Skip
            </Button>
            <Button type="submit" variant="primary" onClick={() => setShowModal(false)}>
              Save & Continue 
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default LocationCompletionModal;
